import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { CompensationService } from '../services/compensation.service';
import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ActivatedRoute } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';

@Component({
  selector: '',
  template: '',
})
export class EvaluationTrackingSearchHandler extends BaseSearchComponent<CompensationService> implements OnInit {
  isAdvanceSearchDisplayed: boolean;
  public searchName: string;
  public searchCompltedName: string;
  public fullPath;
  public agentId;
  private pathSegments;
  searchCriteriaData: any;
  activeTab: 'ongoing' | 'completed' = 'ongoing';

  ongoingItems = [];
  completedItems = [];
  searchConfig: any = {
    'search-contest': {
      headerKey: 'contestInquiry',
      ongoingSearchName: 'SearchContest',
      completedSearchName: 'SearchCompletedContest',
    },
    'search-incentive': {
      headerKey: 'incentiveInquiry',
      ongoingSearchName: 'SearchIncentive',
      completedSearchName: 'SearchCompletedIncentive',
    },
    'search-team-contest/:agentId/:agentName': {
      headerKey: 'teamContest',
      ongoingSearchName: 'SearchTeamContest',
      completedSearchName: 'SearchCompletedTeamContest',
    },
    'search-team-incentive/:agentId/:agentName': {
      headerKey: 'teamIncentive',
      ongoingSearchName: 'SearchTeamIncentive',
      completedSearchName: 'SearchCompletedTeamIncentive',
    },
    'search-evaluation': {
      headerKey: 'evaluationInquiry',
      ongoingSearchName: 'SearchEvaluation',
      completedSearchName: 'SearchCompletedEvaluation',
    },
  };

  constructor(
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.pathSegments = this.route.snapshot.url;
    this.fullPath = this.pathSegments.map((segment) => segment.path).join('/');
    this.searchConfig = this.resolveConfigFromPath(this.fullPath);
    this.agentId = this.route.snapshot.paramMap.get('agentId');
    this.onActiveOnGoingTabClick();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    const breadcrumbs: BreadCrumb[] = [
      {
        id: 'home',
        link: '/home',
      },
    ];

    if (this.pathSegments.length > 1) {
      breadcrumbs.push({
        id: 'My Team Details',
        link: '/search-my-team-details',
      });
    }

    breadcrumbs.push({
      id:
        this.pathSegments.length > 1
          ? this.pathSegments[2]?.path || ''
          : this.pathSegments.length === 1
          ? this.pathSegments[0].path
          : '',
    });

    return breadcrumbs;
  }

  protected getPageHeader(): PageHeader {
    const header = new PageHeader();
    header.title = this.searchConfig ? this.settingService.getLabelValue(this.searchConfig.headerKey) : '';
    return header;
  }

  ngOnInit() {
    super.ngOnInit();
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  onActiveOnGoingTabClick() {
    this.activeTab = 'ongoing';
    if (this.searchConfig) {
      this.getSearchList(this.searchConfig.ongoingSearchName);
    }
  }

  onActiveCompletedTabClick() {
    this.activeTab = 'completed';
    if (this.agentId) {
      this.searchCriteriaData = { 'EvaluationResultDO.agentId': this.agentId };
    }
    if (this.searchConfig) {
      this.searchCompltedName = this.searchConfig.completedSearchName;
    }
  }

  getSearchList(searchText: string) {
    if (this.activeTab == 'ongoing') {
      if (this.agentId != undefined && this.agentId != null) {
        this.searchCriteriaData = { 'EvaluationResultDO.agentId': this.agentId };
      }
      this.service.getSearchList(searchText, true, this.searchCriteriaData).subscribe(
        (response: any) => {
          const searchList = JSON.parse(JSON.stringify(response));
          const resultRows = searchList.data.searchResultData || [];
          const columnInfo = searchList.data.searchResultInfo;

          // Map positions to LABELKEYs (for ongoingItems only)
          const labelKeysByPosition: string[] = Object.keys(columnInfo)
            .sort((a, b) => columnInfo[a].position - columnInfo[b].position)
            .map((key) => {
              const col = columnInfo[key];
              if (col.LABELKEY) {
                return col.LABELKEY;
              } else if (col.isRecordId) {
                return 'recordId';
              } else if (col.metadata) {
                const parts = col.metadata.split('.');
                return parts[parts.length - 1] || `col_${col.position}`;
              } else {
                return `col_${col.position}`;
              }
            });

          this.ongoingItems = [];
          this.completedItems = [];

          // Get the index of dryRunIndicator column
          const statusIdx = labelKeysByPosition.findIndex((k) => k === 'dryRunIndicator');

          resultRows.forEach((row: any[]) => {
            const status = row[statusIdx]?.toUpperCase();
            const rowObj: any = {};
            row.forEach((val, idx) => {
              const key = labelKeysByPosition[idx];
              rowObj[key] = val;
            });
            if (rowObj.recordId) {
              rowObj.link = `/contest-and-incentive-details/${rowObj.recordId}`;
            } else {
              rowObj.link = null;
            }
            this.ongoingItems.push(rowObj);
          });
        },
        (error) => {
          console.error('Get search list failed.', error);
        }
      );
    }
  }

  private resolveConfigFromPath(path: string) {
    for (const routePattern in this.searchConfig) {
      // Convert route pattern to a regex, replacing :params with a matcher
      const regexPattern = '^' + routePattern.replace(/:[^/]+/g, '[^/]+') + '$';
      const regex = new RegExp(regexPattern);

      if (regex.test(path)) {
        return this.searchConfig[routePattern];
      }
    }

    return null;
  }
}
